import { all, select, call, put } from 'redux-saga/effects';
import axios from 'axios';
import {
  withOffset,
  selectors as streamSelectors,
} from '@wix/da-shared-react/pkg/Stream';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { deviationSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { getProfileOwner } from '../../selectors/users';
import { API_BASE_PATH } from '../../../constants';
import { PapiCommissionsRequestParams } from '../../../types/papi';
import { ShopItemType } from '../../../types/shop';

function fetchFromApi(shopItemType, params) {
  return axios
    .get(`${API_BASE_PATH}/module/${shopItemType}`, { params })
    .catch(response => false);
}

export default function* fetchMoreShopItems(action) {
  const { streamId } = action;

  const [offset, limit, streamParams, profileOwner] = yield all([
    select(state => withOffset.selectors.getNextOffset(state, streamId)),
    select(state => streamSelectors.getItemsPerFetch(state, streamId)),
    select(state => streamSelectors.getStreamParamsSafe(state, streamId)),
    select(getProfileOwner),
  ]);

  const queryParams: PapiCommissionsRequestParams = {
    username: profileOwner.user && profileOwner.user.username,
    moduleid: streamParams.moduleId,
    expand: 'deviation.shop',
    offset,
    limit,
  };

  const shopItemType: ShopItemType = streamParams.shopItemType;

  const response = yield call(fetchFromApi, shopItemType, queryParams);

  if (response && response.status === 200) {
    const { hasMore, total, nextOffset, results } = response.data;
    const { result, entities } = normalize(results, [deviationSchema]);

    yield put(
      withOffset.actions.fetchSuccess({
        streamId,
        hasMore,
        nextOffset,
        items: result,
        total,
        entities,
      })
    );
  }
  // TODO error catching
}
